import { DocumentData, QueryDocumentSnapshot } from "@angular/fire/firestore"
import { ModuleStats as BackendModuleStats } from "@longtail-education/superprepstudy-data-model-frontend"
//import { environment } from "@nx-superprep/environment"

/**
 * Represents a module stats.
 * Extends the BackendModuleStat class from the frontend data model.
 */
export class ModuleStats extends BackendModuleStats {
  /** The ID of the module stats. */
  id!: string

  constructor(documentData: DocumentData = {}) {
    super(documentData['moduleId'])
    this.id = documentData['moduleId']
  }

  /**
   * Firestore data converter for ModuleStats.
   */
  static override converter = {
    toFirestore: BackendModuleStats.converter.toFirestore,
    /* alternative for the above method when dev/prod data model differ
    toFirestore(data: BackendModuleStats) {
      const obj = BackendModuleStats.converter.toFirestore(data)
      if (environment.config.isProduction) { delete obj['isAssigned'] }
      return obj
    },
    */
    fromFirestore(snapshot: QueryDocumentSnapshot): ModuleStats {
      const obj = BackendModuleStats.converter.fromFirestore(snapshot)
      return {...obj, id:obj.moduleId} as ModuleStats
    }
  }
}
